<script setup lang="ts">
import type { HeadingVariants } from '~ds/components/ui/typography';

import { Heading } from '~ds/components/ui/typography';

interface Props {
  title: string;
  imageSrc?: string;
  class?: string;
  semanticSize?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
  size?: HeadingVariants['size'];

}
const props = withDefaults(defineProps<Props>(), {
  class: '',
  semanticSize: 'h1',
  size: '3xl',
});
const classes = computed(() => {
  return twMerge('flex w-full items-center mt-12 gap-6 @container', props.class);
});
</script>

<template>
  <div :class="classes">
    <div class="flex min-w-0 flex-col gap-4">
      <Heading
        :size="size"
        :as="semanticSize"
      >
        {{ title }}
      </Heading>
      <slot />
    </div>
    <NuxtImg
      v-if="imageSrc"
      :src="imageSrc"
      alt=""
      class="size-24 shrink-0 object-contain @2xl:size-32"
    />
  </div>
</template>
